import {
    array,
    assign,
    literal,
    nullable,
    number,
    object,
    omit,
    optional,
    string,
} from "superstruct";

import { RewardsFreeProductVariantSchema } from "../RewardsFreeProductSchemas/RewardsFreeProductVariantSchema";

export const RewardsFreeProductRewardSchema = object({
    type: literal("free_product"),
    discountValue: number(),
    productId: number(),
    productHandle: optional(string()),
    productTitle: optional(string()),
    productImage: optional(nullable(string())),
    expirationInDays: nullable(number()),
    variants: array(RewardsFreeProductVariantSchema),
});

export const RewardsFreeProductDiscountCodeRewardSchema = assign(
    omit(RewardsFreeProductRewardSchema, ["variants", "expirationInDays"]),
    object({
        discountCode: string(),
        variantId: number(),
        variantTitle: optional(string()),
        variantImage: optional(nullable(string())),
    })
);
